import { render } from "./EditChannel.vue?vue&type=template&id=54f48a52"
import script from "./EditChannel.vue?vue&type=script&lang=js"
export * from "./EditChannel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__